(() => {
  const run = () => {
    const controls = [...document.querySelectorAll('[data-filter]')];
    const cards = [...document.querySelectorAll('.accessory-card')];
    controls.forEach(control => control.addEventListener('click', () => {
      const filter = control.dataset.filter;
      controls.forEach(item => { item.classList.toggle('is-active', item === control); item.setAttribute('aria-selected', String(item === control)); });
      cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
    }));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run, { once:true }) : run();
})();
